import Settings from '../../../base/menu/airdome/Settings';

const settings: Settings = {
  categoryName: 'Settings',
  current: 'Current'
};

export default settings;
